import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/shared/layout/main.component';

import { LoginComponent } from './components/shared/login/login.component';


import { AuthGuard } from './services/guards/authGuard.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { CcPortalComponent } from './components/cc-portal/cc-portal/cc-portal.component';
import { BillingComponent } from './components/SideComponents/billing/billing.component';
import { StatusHistoryComponent } from './components/SideComponents/status-history/status-history.component';
import { ServiceHistoryComponent } from './components/SideComponents/service-history/service-history.component';
import { PerformanceGraphsComponent } from './components/SideComponents/performance-graphs/performance-graphs.component';
import { TrafficGraphComponent } from './components/SideComponents/traffic-graph/traffic-graph.component';
import { CcAccountTrafficComponent } from './components/shared/cc-account-traffic/cc-account-traffic.component';
import { SplashComponent } from './components/shared/splash/splash.component';
import { CcAccountLinesComponent } from './components/shared/cc-account-lines/cc-account-lines.component';
import { TotalAccountGraphsComponent } from './components/shared/total-account-graphs/total-account-graphs.component';
import { CcLineSummaryComponent } from './components/cc-portal/cc-line-summary/cc-line-summary.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';

const routes: Routes = [
  {
    path: 'splash',
    component: SplashComponent,
    canActivate: [AuthGuard]
  },
  {
    canActivate: [AuthGuard],
    path: 'main',
    component: MainComponent,

  }, {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardComponent

      },
      {
        path: 'linedetails/:lineId',
        component: CcPortalComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'lineSummary',
            component: CcLineSummaryComponent,
            canActivate: [AuthGuard]
          },

        ],
      },
      {
        path: 'accountspeed/:ucid',
        component: CcAccountTrafficComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'accountspeed',
        component: CcAccountTrafficComponent,
        canActivate: [AuthGuard]
      },

      { path: 'line-tickets-full/:quoteid/:id', component: ServiceHistoryComponent, canActivate: [AuthGuard] },
      { path: 'line-status-history-full/:id', component: StatusHistoryComponent, canActivate: [AuthGuard] },
      { path: 'billing/:ucid', component: BillingComponent, canActivate: [AuthGuard] },
      { path: 'device-graph/:id', component: PerformanceGraphsComponent, canActivate: [AuthGuard] },
      { path: 'device-traffic-graph/:id/:isTotal', component: TrafficGraphComponent, canActivate: [AuthGuard] },
      { path: 'branches', component: CcAccountLinesComponent, canActivate: [AuthGuard] },
      { path: 'total-graph', component: TotalAccountGraphsComponent, canActivate: [AuthGuard] },
      { path: 'contact-us', component: ContactUsComponent, canActivate: [AuthGuard] },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '**',
    redirectTo: ''
  }

];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, {})

  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
